
let passErrors = [
    {
      error1: [
        <ul className="list-unstyled " key={0}>
          <li className="text-success  ">
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error2: [
        <ul className="list-unstyled " key={1}>
          <li>Ensure start with  has two uppercase letters.</li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],

      error7: [
        <ul className="list-unstyled " key={2}>
          <li className="text-success">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error8: [
        <ul className="list-unstyled " key={3}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error14: [
        <ul className="list-unstyled" key={4}>
          <li className="text-success">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li>Ensure  has two digits.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error9: [
        <ul className="list-unstyled " key={5}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error10: [
        <ul className="list-unstyled " key={6}>
          <li className="text-success ">
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error11: [
        <ul className="list-unstyled " key={7}>
          <li className="text-success ">
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error12: [
        <ul className="list-unstyled " key={8}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error13: [
        <ul className="list-unstyled" key={9}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error15: [
        <ul className="list-unstyled" key={10}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error16: [
        <ul className="list-unstyled " key={11}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error17: [
        <ul className="list-unstyled " key={12}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li>Ensure  has three lowercase letters.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error18: [
        <ul className="list-unstyled " key={13}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li>Ensure  has three lowercase letters.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error19: [
        <ul className="list-unstyled " key={14}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li>Ensure  has two digits.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error20: [
        <ul className="list-unstyled " key={15}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li className="text-success">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
    },
  ];

  let repassErrors = [
    {
      error1: [
        <ul className="list-unstyled " key={100}>
          <li className="text-success  ">
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error2: [
        <ul className="list-unstyled " key={101}>
          <li>Ensure start with  has two uppercase letters.</li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],

      error7: [
        <ul className="list-unstyled " key={102}>
          <li className="text-success">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error8: [
        <ul className="list-unstyled " key={103}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error14: [
        <ul className="list-unstyled" key={104}>
          <li className="text-success">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li>Ensure  has two digits.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error9: [
        <ul className="list-unstyled " key={105}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li>Ensure  has three lowercase letters.</li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error10: [
        <ul className="list-unstyled " key={106}>
          <li className="text-success ">
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error11: [
        <ul className="list-unstyled " key={107}>
          <li className="text-success ">
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error12: [
        <ul className="list-unstyled " key={108}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li>Ensure  more than 8 .</li>
        </ul>,
      ],
      error13: [
        <ul className="list-unstyled" key={109}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error15: [
        <ul className="list-unstyled" key={110}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li>Ensure  has two digits.</li>
          <li>Ensure  has three lowercase letters.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error16: [
        <ul className="list-unstyled " key={111}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li>Ensure  has two digits.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error17: [
        <ul className="list-unstyled " key={112}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li>Ensure  has three lowercase letters.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error18: [
        <ul className="list-unstyled " key={113}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li>Ensure  has three lowercase letters.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error19: [
        <ul className="list-unstyled " key={114}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            one special case letter.
          </li>
          <li>Ensure  has two digits.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
      error20: [
        <ul className="list-unstyled " key={115}>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure start with
             has two uppercase letters.
          </li>
          <li>Ensure  has one special case letter.</li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            two digits.
          </li>
          <li className="text-success ">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure  has
            three lowercase letters.
          </li>
          <li className="text-success">
            {" "}
            <i className="fa-solid fa-check text-success"></i> Ensure 
            more than 8 .
          </li>
        </ul>,
      ],
    },
  ];
function validate(values) {
    let errors = {};
    if (values.password == "" ) {
      errors.password = "Your Password is Required";
     
    } else {
      errors.password = passErrors[0].error2;
     
      if (values.password.match(/^(?=.*[A-Z].*[A-Z])/)) {
        errors.password = [passErrors[0].error1];
        
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/)
        ) {
          errors.password = [passErrors[0].error7];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.password = [passErrors[0].error9];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.password = [passErrors[0].error8];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.password = [passErrors[0].error10];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.password = [passErrors[0].error14];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.length > 8
        ) {
          errors.password = [passErrors[0].error11];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.length > 8 &&
          values.password.match(/(?=.*[!@#$&*])/)
        ) {
          errors.password = [passErrors[0].error15];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.length > 8 &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.password = [passErrors[0].error16];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.length > 8 &&
          values.password.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.password = passErrors[0].error17;
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.password = [passErrors[0].error12];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/) &&
          values.password.length > 8
        ) {
          errors.password = [passErrors[0].error18];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.password.length > 8
        ) {
          errors.password = [passErrors[0].error19];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.password.length > 8
        ) {
          errors.password = [passErrors[0].error20];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.password.length > 8 &&
          values.password.match(/(?=.*[!@#$&*])/)
        ) {
          if (errors.password != "") {
            errors = {};
          }
        }
      }
    }
    if (values.rePassword == "") {
      errors.rePassword = "Your confirm password is Required";
    } else if (values.rePassword != values.password) {
      errors.rePassword = "Your confirm password not match";
    }

    if (values.name == "") {
      errors.name = "Your name is Required";
    } else if (values.name.length < 8) {
      errors.name = "Your name must be more 8 chars";
    }
    if (values.email == "") {
      errors.email = "Your email is Required";
    } else if (
      !values.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
    ) {
      errors.email = "Your email not valid";
    }
    if (values.phone == "") {
      errors.phone = "Your phone is Required";
    } else if (!values.phone.match(/^(02)?01[0125][0-9]{8}$/)) {
      errors.phone = "Your phone not valid";
    }

    return errors;
  }
 export function Validate(values) {
    let errors = {};
    if (values.newPassword == "" ) {
      errors.newPassword = "Your Password is Required";
     
    } else {
      errors.newPassword = passErrors[0].error2;
     
      if (values.newPassword.match(/^(?=.*[A-Z].*[A-Z])/)) {
        errors.newPassword = [repassErrors[0].error1];
        
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[!@#$&*])/)
        ) {
          errors.newPassword = [repassErrors[0].error7];
        }

        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.newPassword = [repassErrors[0].error9];
        }

        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[!@#$&*])/) &&
          values.newPassword.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.newPassword = [repassErrors[0].error8];
        }

        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.newPassword = [repassErrors[0].error10];
        }
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[!@#$&*])/) &&
          values.newPassword.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.newPassword = [repassErrors[0].error14];
        }
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.length > 8
        ) {
          errors.newPassword = [repassErrors[0].error11];
        }
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.length > 8 &&
          values.newPassword.match(/(?=.*[!@#$&*])/)
        ) {
          errors.newPassword = [repassErrors[0].error15];
        }
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.length > 8 &&
          values.newPassword.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.newPassword = [repassErrors[0].error16];
        }
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.length > 8 &&
          values.newPassword.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.newPassword = repassErrors[0].error17;
        }
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[!@#$&*])/) &&
          values.newPassword.match(/(?=.*[0-9].*[0-9])/) &&
          values.newPassword.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.newPassword = [repassErrors[0].error12];
        }

        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[!@#$&*])/) &&
          values.newPassword.match(/(?=.*[0-9].*[0-9])/) &&
          values.newPassword.length > 8
        ) {
          errors.newPassword = [repassErrors[0].error18];
        }
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[!@#$&*])/) &&
          values.newPassword.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.newPassword.length > 8
        ) {
          errors.newPassword = [repassErrors[0].error19];
        }
        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[0-9].*[0-9])/) &&
          values.newPassword.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.newPassword.length > 8
        ) {
          errors.newPassword = [repassErrors[0].error20];
        }

        if (
          values.newPassword.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.newPassword.match(/(?=.*[0-9].*[0-9])/) &&
          values.newPassword.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.newPassword.length > 8 &&
          values.newPassword.match(/(?=.*[!@#$&*])/)
        ) {
          if (errors.newPassword != "") {
            errors= {};
          }
        }
      }
    }

   
   

    return errors;
  }

  export function changePassValidation(values) {
    let errors = {};
    if (values.password == "" ) {
      errors.password = "Your Password is Required";
     
    } else {
      errors.password = passErrors[0].error2;
     
      if (values.password.match(/^(?=.*[A-Z].*[A-Z])/)) {
        errors.password = [passErrors[0].error1];
        
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/)
        ) {
          errors.password = [passErrors[0].error7];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.password = [passErrors[0].error9];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.password = [passErrors[0].error8];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.password = [passErrors[0].error10];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.password = [passErrors[0].error14];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.length > 8
        ) {
          errors.password = [passErrors[0].error11];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.length > 8 &&
          values.password.match(/(?=.*[!@#$&*])/)
        ) {
          errors.password = [passErrors[0].error15];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.length > 8 &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.password = [passErrors[0].error16];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.length > 8 &&
          values.password.match(/(?=.*[0-9].*[0-9])/)
        ) {
          errors.password = passErrors[0].error17;
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/)
        ) {
          errors.password = [passErrors[0].error12];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/) &&
          values.password.length > 8
        ) {
          errors.password = [passErrors[0].error18];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[!@#$&*])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.password.length > 8
        ) {
          errors.password = [passErrors[0].error19];
        }
        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.password.length > 8
        ) {
          errors.password = [passErrors[0].error20];
        }

        if (
          values.password.match(/(?=.*[A-Z].*[A-Z])/) &&
          values.password.match(/(?=.*[0-9].*[0-9])/) &&
          values.password.match(/(?=.*[a-z].*[a-z].*[a-z])/) &&
          values.password.length > 8 &&
          values.password.match(/(?=.*[!@#$&*])/)
        ) {
          if (errors.password != "") {
            errors = {};
          }
        }
      }
    }
    if (values.rePassword == "") {
      errors.rePassword = "Your confirm password is Required";
    } else if (values.rePassword != values.password) {
      errors.rePassword = "Your confirm password not match";
    }
    if (values.currentPassword == "") {
      errors.currentPassword = "Your current password is Required";
    }

    return errors;
  }

  export function changeProfileValidation(values) {

    let errors = {};

    if (values.name == "") {
      errors.name = "Your name is Required";
    } else if (values.name.length < 8) {
      errors.name = "Your name must be more 8 chars";
    }
    if (values.email == "") {
      errors.email = "Your email is Required";
    } else if (
      !values.email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
    ) {
      errors.email = "Your email not valid";
    }
    if (values.phone == "") {
      errors.phone = "Your phone is Required";
    } else if (!values.phone.match(/^(02)?01[0125][0-9]{8}$/)) {
      errors.phone = "Your phone not valid";
    }

    return errors;
  }
    
  
  export default validate;